import React from 'react';

const Hero2 = () => {
  return (
    <div className="hero2">
      <div className="hero2__header">
        <h1>Lenovo Gives Wildlife Conservation an Edge</h1>
      </div>
      <div className="hero2__subhead">
        <p>
          How Lenovo’s Work For Humankind project and a nature conservation group created a
          one-of-a-kind edge-computing experiment at the edge of the world.
        </p>
      </div>
    </div>
  );
};

export default Hero2;
